export function formatResponseTargets(targets: Record<string, string[]>): string[] {
  return Object.entries(targets).flatMap(([targetType, values]) => {
    const label = TARGET_LABELS.get(targetType) ?? targetType;
    return values.map((value) => `${label}: ${value}`);
  });
}

const TARGET_LABELS = new Map([
  ["ips", "IP"],
  ["account_ids", "Account ID"],
  ["token_id", "Token"],
]);
